import { useSyncExternalStore } from 'react'

const subscribe = (onChange: () => void) => {
  document.addEventListener('visibilitychange', onChange)
  return () => document.removeEventListener('visibilitychange', onChange)
}

const getSnapshot = () => document.visibilityState === 'visible'

const getServerSnapshot = () => true

export const usePageVisibility = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
